module.exports = __webpack_public_path__ + "img/yoga-flow.86b68a4e.webp";